import { customerOperationError } from "./error-presentation.js";

// A stalled fetch or response body must not leave account startup pending forever.
// This bounds reads only: mutations keep their existing single-attempt semantics.
export async function withReadDeadline(operation, { timeoutMs = 15000, signal } = {}) {
  const controller = new AbortController();
  let timer;
  let rejectDeadline;
  const deadline = new Promise((_, reject) => { rejectDeadline = reject; });
  const cancel = () => {
    controller.abort();
    rejectDeadline(customerOperationError("pirdy_network_error"));
  };
  if (signal?.aborted) cancel();
  else signal?.addEventListener("abort", cancel, { once: true });
  timer = globalThis.setTimeout(cancel, timeoutMs);
  try {
    return await Promise.race([Promise.resolve().then(() => {
      if (controller.signal.aborted) throw customerOperationError("pirdy_network_error");
      return operation(controller.signal);
    }), deadline]);
  } finally {
    globalThis.clearTimeout(timer);
    signal?.removeEventListener("abort", cancel);
  }
}
